import type { SubCondition } from './HubOptionState.types';
import { HubOptionStateValue, ConditionQuantifier } from './HubOptionState.types';

export type ReplayDefaults = {
  state: HubOptionStateValue;
  text: string;
  gotoBranchId: number | null;
  iconId: number | null;
};

export type ReplayCondition = {
  uuid: string;
  quantifier: ConditionQuantifier;
  subConditions: SubCondition[];
  /** Nullable — condition may override only goto/icon/text without changing state. */
  resultState: HubOptionStateValue | null;
  resultIconId: number | null;
  resultText: string | null;
  resultGotoBranchId: number | null;
};

export const HUB_MAX_REPLAY_CONDITIONS = 5;
